import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { WhatIsSection } from './components/WhatIsSection';
import { AudienceSection } from './components/AudienceSection';
import { ModulesSection } from './components/ModulesSection';
import { BonusesSection } from './components/BonusesSection';
import { ProblemSection } from './components/ProblemSection';
import { MethodSection } from './components/MethodSection';
import { ValueStackSection } from './components/ValueStackSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { ClosingSection } from './components/ClosingSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '2226605141499138';
export function App() {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-canvas font-sans text-ink selection:bg-gold-soft" data-id="element-0" data-mp="38l8iru2c62iy">
      <noscript data-id="element-1" data-mp="3dkl0k0ecojeo">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3dl4ktnrh3jvv" />
      </noscript>

      <Hero data-id="element-3" data-mp="stcc2fmhxkt6" />
      <main data-id="element-4" data-mp="sssr0q1jugax">
        <WhatIsSection data-id="element-5" data-mp="swq9d9gaz3tr" />
        <AudienceSection data-id="element-6" data-mp="3686tkdjumw2" />
        <ModulesSection data-id="element-7" data-mp="35glr3hkw7k1" />
        <BonusesSection data-id="element-8" data-mp="34x4lozr5n72" />
        <ProblemSection data-id="element-9" data-mp="38b66v0ldsdg" />
        <MethodSection data-id="element-10" data-mp="3udaw269tuj3n" />
        <ValueStackSection data-id="element-11" data-mp="3ubriwojgwo63" />
        <PricingSection data-id="element-12" data-mp="3ucj8niqdvrog" />
        <GuaranteeSection data-id="element-13" data-mp="d4nv7fl6zi1v" />
        <FAQSection data-id="element-14" data-mp="d4xr1jsx4jfh" />
        <ClosingSection data-id="element-15" data-mp="d3cr1enu48a8" />
        <FinalCTA data-id="element-16" data-mp="d2l7x3bfc30u" />
      </main>
      <Footer data-id="element-17" data-mp="85ully910b6z" />
    </div>;
}